import { useContext, useMemo } from 'react';
import moment from 'moment';
import t from 'react-translate';

import { css } from '@emotion/react';
import { gray1, info } from 'styles/global_defaults/colors';

import { getCalendarIntegrationSettings } from 'redux/selectors/mentorship-program-sessions';
import { useSelector } from 'react-redux';

import MentoringProgramContext from 'athena/components/mentoring-program/context';
import useConnection from 'athena/hooks/use-connection';

import { CalendarIntegrationPayload } from '../utils';

const styles = css`
  background-color: ${info};
  color: ${gray1}
`;

const AvailabilityCalendarNote = () => {
  const translations = (
    t.MENTORING_PROGRAMS.PARTICIPANT_HOME.PLAN_SESSION_FLYOUT.EDIT_MODE.SCHEDULING_WITH_AVAILABILITY.AVAILABILITY_CALENDAR.NOTE
  );
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { mentorshipProgramEnrollment, id: mentoringProgramId } = mentoringProgram;
  const { connection } = useConnection(mentorshipProgramEnrollment);
  const connectionCalendarIntegrationSettings: CalendarIntegrationPayload = useSelector(
    getCalendarIntegrationSettings(mentoringProgramId, connection.assignedEnrollment.id),
  );

  const isConnectionAuthenticated = useMemo(() => (
    moment(connectionCalendarIntegrationSettings?.expiresAt).isAfter(moment())
  ), [connectionCalendarIntegrationSettings?.expiresAt]);

  const note = useMemo(() => (
    isConnectionAuthenticated
      ? translations.BOTH_CONNECTED(connection.assignedEnrollment.user.firstName)
      : translations.ONE_CONNECTED()
  ), [isConnectionAuthenticated]);

  return (
    <div className='text-small text-gray2 pb-2 px-4' css={styles}>
      {note}
    </div>
  );
};

export default AvailabilityCalendarNote;
